var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "padding": "20px",
      "box-sizing": "border-box",
      "position": "fixed",
      "background-color": "#fff",
      "z-index": "1000",
      "width": "440px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "bold",
      "padding": "10px 0"
    }
  }, [_vm._v("更新日志")]), _vm._v(" "), (!_vm.query.keywords) ? _c('Input', {
    ref: "input:keywords",
    attrs: {
      "icon": "ios-search",
      "placeholder": '搜索'
    },
    on: {
      "on-enter": _vm.keywordsChanged
    },
    model: {
      value: (_vm.keywords),
      callback: function($$v) {
        _vm.keywords = $$v
      },
      expression: "keywords"
    }
  }) : _vm._e(), _vm._v(" "), ((!!_vm.query.keywords)) ? _c('div', {
    staticClass: "jcsb nowrap",
    style: ("height: 32px;line-height: 32px;margin: 0;width: 100%;background-color: #f5f5f5;color: #aaa;padding: 0 8px;border-radius: 4px;"),
    on: {
      "click": _vm.keywordsEdit
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.query.keywords))]), _vm._v(" "), _c('Icon', {
    attrs: {
      "type": "ios-close-circle"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.keywordsClear($event)
      }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100px"
    }
  }), _vm._v(" "), _c('Scroll', {
    ref: "list",
    attrs: {
      "on-reach-top": _vm.refresh,
      "on-reach-bottom": _vm.loadMore,
      "distance-to-edge": 20,
      "height": _vm.listHeight
    }
  }, [_vm._l((_vm.gengxinrizhis), function(gengxinrizhi, index) {
    return _c('div', {
      staticClass: "gengxinrizhi",
      style: (("background-color: " + (index%2==0?'#fff':'#fafafa') + ";"))
    }, [_c('Badge', {
      attrs: {
        "dot": _vm.newversiontip(gengxinrizhi),
        "offset": [5, -6]
      }
    }, [_c('div', {
      staticStyle: {
        "font-size": "18px",
        "font-weight": "bold"
      }
    }, [_c('Icon', {
      attrs: {
        "type": "md-bookmark"
      }
    }), _vm._v("\n                    " + _vm._s(gengxinrizhi.version) + "\n                ")], 1)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-size": "14px",
        "color": "#aaa",
        "margin-bottom": "10px"
      }
    }, [_vm._v("文档更新于 " + _vm._s(gengxinrizhi.lastUpdateTimeStr))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(gengxinrizhi.content)
      }
    })], 1)
  }), _vm._v(" "), (_vm.nomore) ? _c('div', {
    staticClass: "nomore"
  }, [_vm._v("没有更多了")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px"
    }
  })], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39a357e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Updatelog.vue
// module id = BFc2
// module chunks = 142